export const annotations = [
  {
    'created_at': 1630574818,
    'user_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5a',
    'patient_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'description': 'این یک متن چند \n خطی است.'
  },
  {
    'created_at': 1630575118,
    'user_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5b',
    'patient_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'description': 'این یک متن چند \n خطی است. 22'
  },
  {
    'created_at': 1630575818,
    'user_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5f',
    'patient_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'description': 'این یک متن چند \n خطی است. 33'
  }
]



// WEBPACK FOOTER //
// ./src/_helpers/backend-data/annotation.js